/**
 * Provides the best appropriate parent element for a popover.
 * This helps resolve z-index issues by preventing the situation where the popover is rendered behind a modal
 */
export function getParentForPopover(triggerElement: HTMLElement | null, defaultParent = document.body): HTMLElement {
  if (!triggerElement) {
    console.error('Trigger element is null, you probably need to use forwardRef or bind it to a default HTML element or non-functional component')
    return defaultParent
  }

  const closestModalRoot = triggerElement.closest('.MuiDialog-container') as HTMLElement | null
  if (closestModalRoot) return closestModalRoot
  return defaultParent
}
